<template>
  <a-layout-sider><h1><a-icon type="tool" />侧边栏建设中...</h1></a-layout-sider>
</template>

<script>
export default {

}
</script>

<style>

</style>